import { DealerUserRole, SupportViewType } from "@/gql/graphql";
import { z } from "zod";

const roleSessionSchema = z.object({
  viewType: z.literal(SupportViewType.Role),
  cdhId: z.string().min(1),
  iamAccountId: z.string().min(1),
  accountName: z.string(),
  targetRoleId: z.enum([
    DealerUserRole.DealerOwner,
    DealerUserRole.DealerSecondaryOwner,
    DealerUserRole.DealerTechnician,
    DealerUserRole.SalesOrderAdmin,
  ]),
});

const userSessionSchema = z.object({
  viewType: z.literal(SupportViewType.User),
  cdhId: z.string().min(1),
  iamAccountId: z.string().min(1),
  accountName: z.string(),
  targetUserId: z.string().min(1),
  targetUserDisplayName: z.string().min(1),
});

const supportModeSessionSchema = z.discriminatedUnion("viewType", [
  roleSessionSchema,
  userSessionSchema,
]);

export type SupportModeRoleSession = z.infer<typeof roleSessionSchema>;
export type SupportModeUserSession = z.infer<typeof userSessionSchema>;
export type SupportModeSession = z.infer<typeof supportModeSessionSchema>;

export const parseSupportModeSession = (
  value: unknown
): SupportModeSession | null => {
  const result = supportModeSessionSchema.safeParse(value);
  return result.success ? result.data : null;
};
